import React, {useCallback, useEffect, useState} from "react";
import {Link, useLocation, useParams} from "react-router-dom";
import {Spinner} from "../../components/Spinner";
import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import TextInputItem from "../../components/TextInputItem";
import {
  convertAgent,
  selectApp,
  setAgent
} from "../app/appSlice";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getHtiHostedImageURL, storeAgentLogin} from "../Util";
import {
  buildPasswordRestrictions,
  getErrorMessage,
  getRestrictionName,
  getSinglePropertyId, getValidationFn, handleAppleAuth, handleForgotPassword,
  handleGoogleAuth,
  handleMicrosoftAuth,
  handlePasswordAuth, handlePasswordSignUp, handleResendEmail,
  isErrorAuthResponse,
  processAuthErrorRS
} from "../app/appUtil";
import {DIRECT_AUTH, getApiUrl} from "../../api/client";
import useRestFetch, {FETCH} from "../../hooks/useRestFetch";
import {getAuth, validatePassword} from "firebase/auth";
import {useNavigate} from "react-router";
import {getResults, selectResults} from "../results/resultsSlice";
import {useNebulaAuth} from "../../hooks/useNebulaAuth";
import {firebaseAppNebulaOne} from "../../App";
import {processInviteTokenError} from "./signupUtil";

const Error = ({message}) => {

  return (
      <div className={'bn-error-message'}>
        <p>{message}</p>
      </div>
  )
}

export default React.memo(function () {

  const navigate = useNavigate();
  const location = useLocation()

  const {inviteToken} = useParams();

  const {
    criteria,
    hasResults,
    site, singleProperty} = useSelector(
      state => ({
        loginBusy: selectApp(state).loginBusy,
        errorType: selectApp(state).errorType,
        criteria: selectResults(state).criteria,
        hasResults: selectResults(state).hasResults,
        site: selectApp(state).site,
        singleProperty: selectApp(state).singleProperty,
      }));
  const customer = useSelector(state => selectApp(state).customer);
  const token = useSelector(state => selectApp(state).token);

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('');
  const [forgetPassword, setForgetPassword] = useState(false);
  const [passwordRestrictions, setPasswordRestrictions] = useState([])
  const [register, setRegister] = useState(false)
  const [emailSent, setEmailSent] = useState(false);
  const [emailVerifySent, setEmailVerifySent] = useState(false)
  const [resendEmail, setResendEmail] = useState(false)
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(undefined);

  const {authSSO, busy: authSSOBusy} = useNebulaAuth();
  const {fetch: fetchContact, busy: contactFetchBusy} = useRestFetch();
  const {fetch: validateToken, busy: tokenBusy, error: tokenError} = useRestFetch();

  const auth = getAuth(firebaseAppNebulaOne);

  const dispatch = useDispatch();
  const getResults_ = useCallback((criteria) => dispatch(getResults(criteria)),
      [dispatch]);

  useEffect(() => {
    setEmail('');
    setPassword('');

    handleRegister(true)
  }, []);

  const signInSuccess = useCallback((email, idToken) => {

    if(customer) {
      authSSO(email, idToken, getApiUrl(customer, DIRECT_AUTH), 'cb').then(
          response => {

            // console.log('authSSO rs', response)

            if (!isErrorAuthResponse(response.data)) {
              // fetch contact on success
              const user = response.data;

              fetchContact({
                    ID: user.contactId,
                  }, 'Contact', 'withoutPassword', FETCH,
                  customer, user.token).then(r => {
                if (!r.error) {

                  const agent = convertAgent(r[0]);
                  storeAgentLogin(agent);
                  dispatch(setAgent({agent}))

                  if (location.pathname.indexOf("/confirmation/") === -1) { // only redict if not on confirmation page
                    navigate(
                        !singleProperty ? '/' : `/hotel/${getSinglePropertyId(
                            site)}`)

                    if (hasResults) {
                      getResults_(Object.assign({}, criteria,
                          {agentId: agent.agentId}));
                    }
                  } else {
                    window.location.reload();
                  }
                }
              });

            } else {
              console.error('error', response.data)

              setError(processAuthErrorRS(response.data));
            }

          }).catch(error => {
        console.error('error', error)

        setError(getErrorMessage(error))
      })
    }

  }, [customer, authSSO]);

  const handleRegister = (register) => {
    setRegister(register)
    setEmail('')
    setPassword('')
    setError('')
  }

  const handlePasswordOnChange = (value) => {
    setPassword(value)

    if(!passwordRestrictions || passwordRestrictions.length === 0) {
      validatePassword(auth, 'password').then(status => {

        const {passwordPolicy} = status;

        setPasswordRestrictions(buildPasswordRestrictions(passwordPolicy))
      });
    }
  }

  const doValidateInviteToken = (email, inviteToken, auth, password,
      signInSuccess, setBusy, setError, customer, token) => {
    validateToken({
      token: inviteToken,
      email: email,
    }, 'OpenInviteToken', 'validateInvite', FETCH, customer, token)
    .then(r => {

      if(r[0].valid) {
        handlePasswordSignUp(auth, email, password, setEmailVerifySent, setBusy, setError)
      } else {
        setError(processInviteTokenError(r[0].error))
      }

    }).catch(error => {
      console.error('error validating token', error)
    })
  }

  return(
      <div className={"bn-agent-signup-container"}>
        {!register && !forgetPassword &&
            <div className={"bn-agent-login-container"}>
              <div className={'bn-agent-login-header-container'}>
                <h4>Agent Login</h4>
                <div className={"bn-agent-login-signup-link-container"}>
                  Don't have an account?
                  <Link style={{cursor: "pointer"}}
                        onClick={() => handleRegister(true, auth,
                            passwordRestrictions)}>Sign
                    up</Link>
                </div>
              </div>
              <div className={'bn-inputs-group'}>
                <TextInputItem className={"bn-group bn-input-item"}
                               type={"text"}
                               id={"email"}
                               label={"E-mail"}
                               placeholder={"E-mail"}
                               mandatory={true}
                               maxLength={50}
                               value={email}
                               onChange={(event) => setEmail(
                                   event.target.value)}
                />
                <TextInputItem className={"bn-group bn-input-item"}
                               type={"password"}
                               id={"password"}
                               label={'Password'}
                               placeholder={'Password'}
                               mandatory={true}
                               maxLength={50}
                               value={password}
                               onChange={(event) => setPassword(
                                   event.target.value)}
                />
              </div>

              <div className={"bn-forgot-password-container"}>
                <Link style={{cursor: "pointer"}}
                      onClick={() => {
                        setForgetPassword(true)
                        setEmailSent(false)
                        setEmail('')
                        setPassword('')
                        setError(undefined)
                      }}>Forgot password?</Link>
              </div>

              {error && <Error message={error}/>}

              {emailVerifySent && <div className={'bn-agent-signup-verify-sent-container'}>
                <p>Please check your email to verify your account.</p>
              </div>}

              <div className={"bn-dialog-button-container"}>
                {(!resendEmail && !emailVerifySent) && <button className={'bn-booknow-button'}
                         disabled={!email || !password || busy}
                         onClick={() => handlePasswordAuth(auth, email,
                             password,
                             signInSuccess, setResendEmail, setBusy, setError)}
                >Sign In</button>}

                {resendEmail && <button className={'bn-booknow-button'}
                                        disabled={!email || !password || busy}
                                        onClick={() => handleResendEmail(auth,
                                            email,
                                            password,
                                            setResendEmail,
                                            setEmailVerifySent,
                                            setBusy, setError)}
                >Resend E-mail</button>}
              </div>

              <div className={'bn-agent-login-diver-container'}>
                <div className={'bn-agent-login-diver'}/>
                OR
                <div className={'bn-agent-login-diver'}/>
              </div>

              {authSSOBusy && <div className={'bn-agent-login-progress-container'}>
                <Spinner size={'18px'} />
              </div>}

              {!authSSOBusy && <div className={'bn-agent-login-alternate-logins-container'}>
                Sign in with

                <div className={'bn-agent-login-alternate-login-img-container'}>
                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleGoogleAuth(auth, signInSuccess,
                          setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-google.png')} alt={'Google account'}/>
                  </div>}

                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleMicrosoftAuth(auth,
                          signInSuccess, setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-microsoft.png')} alt={'Microsoft account'}/>
                  </div>}

                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleAppleAuth(auth, signInSuccess,
                          setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-apple.png')} alt={'Apple account'}/>
                  </div>}
                </div>
              </div>}

            </div>}
        {register &&
            <div className={'bn-agent-login-container'}>
              <div className={'bn-agent-login-header-container'}>
                <h4>Registration</h4>
                <div className={"bn-agent-login-signup-link-container"}>
                  Already have an account?
                  <Link style={{cursor: "pointer"}}
                        onClick={() => handleRegister(false, auth,
                            passwordRestrictions)}>Login</Link>
                </div>
              </div>
              <div className={'bn-inputs-group'}>
                <TextInputItem className={"bn-group bn-input-item"}
                               type={"text"}
                               id={"email"}
                               label={"E-mail"}
                               placeholder={"E-mail"}
                               mandatory={true}
                               maxLength={50}
                               value={email}
                               onChange={(event) => setEmail(
                                   event.target.value)}
                />
                <TextInputItem className={"bn-group bn-input-item"}
                               type={"password"}
                               id={"password"}
                               label={'Password'}
                               placeholder={'Password'}
                               mandatory={true}
                               maxLength={50}
                               value={password}
                               onChange={(event) => handlePasswordOnChange(
                                   event.target.value)}
                />
              </div>

              {passwordRestrictions && <div className={'bn-password-restrictions'}>
                <div className={'bn-password-progress'}>
                  {passwordRestrictions.map((restriction, idx) => {
                    const validate = getValidationFn(restriction, password);
                    return (
                        <div key={idx} className={classNames('bn-progress-item', {
                          'valid': validate(restriction, password)
                        })}/>)
                  })}
                </div>
                <ul>
                  {passwordRestrictions.map((restriction, idx) => {
                    const validate = getValidationFn(restriction, password);
                    return (
                        <li key={idx} className={classNames('bn-restriction-item', {
                          'valid': validate(restriction, password)
                        })}><FontAwesomeIcon
                            icon="fa-solid fa-check"/> {getRestrictionName(restriction)}</li>)
                  })}
                </ul>
              </div>}

              {error && <Error message={error}/>}

              {tokenError && <Error message={processInviteTokenError(tokenError)}/>}

              {emailVerifySent && <div className={'bn-agent-signup-verify-sent-container'}>
                <p>Please check your email to verify your account.</p>
              </div>}

              {!emailVerifySent && <div className={'bn-dialog-button-container'}>
                <button className={'bn-booknow-button'}
                        disabled={!email || !password || busy || tokenBusy}
                        onClick={() => doValidateInviteToken(email, inviteToken,
                            auth, password, signInSuccess, setBusy, setError,
                            customer, token)}
                >Sign Up
                </button>
              </div>}

              <div className={'bn-agent-login-diver-container'}>
                <div className={'bn-agent-login-diver'}/>
                OR
                <div className={'bn-agent-login-diver'}/>
              </div>

              {authSSOBusy && <div className={'bn-agent-login-progress-container'}>
                <Spinner size={'18px'} />
              </div>}

              {!authSSOBusy && <div className={'bn-agent-login-alternate-logins-container'}>
                Sign in with

                <div className={'bn-agent-login-alternate-login-img-container'}>
                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleGoogleAuth(auth, signInSuccess,
                          setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-google.png')} alt={'Google account'}/>
                  </div>}

                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleMicrosoftAuth(auth,
                          signInSuccess, setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-microsoft.png')} alt={'Microsoft account'}/>
                  </div>}

                  {customer && <div
                      className={'bn-agent-login-alternate-login-img'}
                      onClick={() => handleAppleAuth(auth, signInSuccess,
                          setBusy,
                          setError)}>
                    <img src={getHtiHostedImageURL(customer,
                        'icon-apple.png')} alt={'Apple account'}/>
                  </div>}
                </div>
              </div>}
            </div>
        }

        {
            forgetPassword && <div className={'bn-agent-login-container'}>
              <div className={'bn-agent-login-header-container'}>
                <h4>Forgot Password</h4>
                <div className={'bn-agent-login-signup-link-container'}>
                  Already know your password?
                  <Link style={{cursor: "pointer"}}
                        onClick={() => {
                          setForgetPassword(false)
                          setError(undefined)
                        }}>Login</Link>
                </div>
              </div>
              <div className={'bn-agent-login-forgot-password-description'}>
                Please enter the E-mail associated with your account.
              </div>
              <div className={'bn-inputs-group'}>
                <TextInputItem className={"bn-group bn-input-item"}
                               type={"text"}
                               id={"email"}
                               label={"E-mail"}
                               placeholder={"E-mail"}
                               mandatory={true}
                               maxLength={50}
                               value={email}
                               onChange={(event) => setEmail(
                                   event.target.value)}
                />
              </div>

              <div className={'bn-dialog-button-container'}>
                {!emailSent && <button className={'bn-booknow-button'}
                                       disabled={!email || busy}
                                       onClick={() => handleForgotPassword(auth, email, setEmailSent,
                                           setBusy, setError)}
                >Send E-mail
                </button>}
                {emailSent && <button className={'bn-booknow-button'}
                                      disabled={busy}
                                      onClick={() => setForgetPassword(false)}
                >Sign In
                </button>}
              </div>
            </div>
        }
      </div>
  )
});